export default __webpack_public_path__ + "1d0e01b2d940034cccdb1058807a48d1.ogg";